












import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {DynamicDocumentUtils} from '@/views/dynamicdocuments/dynamic-document.utils';
import DynamicDocumentScreenWidthConfigurationTemplate from '../fields/dynamic-document-screen-width-configuration-template.vue';
import DynamicDocumentMachineWorkingAreaBoundaryFieldTemplate from '@/views/dynamicdocuments/fields/dynamic-document-machine-working-area-boundary-field-template.vue';

@Component({
  name: 'dynamic-document-machine-working-area-boundary-brick-template',
  components: {
    DynamicDocumentScreenWidthConfigurationTemplate,
    DynamicDocumentMachineWorkingAreaBoundaryFieldTemplate
  }
})
export default class DynamicDocumentMachineWorkingAreaBoundaryBrickTemplate extends Vue {

  @Prop({required: true}) fieldConfig: DisguiseDto.DynamicDocumentFieldTypeMachineWorkingAreaBoundaryDtoV2 | undefined;

  sizes = DynamicDocumentUtils.SIZE_SELECTOR;

}
